import React from 'react';

import { PrimaryButton } from '@crehana/ui';
import { useTranslation } from '@crehana/i18n';
import { createUrlWithSourceQueryParams } from '@crehana/analytics';

import getStaticUrl from 'Utils/getStaticUrl';

const bgDesktopWebp = getStaticUrl(
  'img/catalog/courses-free-banner/courses-free-banner-bg.webp',
);

const bgDesktopJpg = getStaticUrl(
  'img/catalog/courses-free-banner/courses-free-banner-bg.jpg',
);

export const getFeatureFlagFromInitialState = (featureFlagName: string) =>
  window && window.__INITIAL_STATE__ && window.__INITIAL_STATE__.feature_flags
    ? window.__INITIAL_STATE__.feature_flags.find(
        f => f.key === featureFlagName,
      )
    : false;

const BannerPremiumTrialDesktop = () => {
  const { t } = useTranslation();
  const isSOFEEnabled = getFeatureFlagFromInitialState(
    'enable_sofe_membership',
  );

  const urlWithSource = createUrlWithSourceQueryParams({
    url: '/registro/',
    source: 'Catalog',
    sourceDetail: 'Banner Premium Trial CTA',
  });

  const redirectTo = () => {
    window.location.href = urlWithSource;
  };

  if (!isSOFEEnabled) return null;

  return (
    <div
      className="relative flex-row hidden w-full sm:flex sm:mb-20 md:mb-32"
      css={`
        background-color: #0f1124;
      `}
    >
      <div
        className="relative flex flex-col items-start px-48 text-left z-1 py-96"
        css={`
          max-width: 40%;
        `}
      >
        <h2 className="mb-16 text-white font-h3">{t('BANNER_FREE_TITLE')}</h2>
        <p className="mb-32 text-white font-subtitle3">
          {t('BANNER_FREE_SUBTITLE')}
        </p>
        <PrimaryButton
          isDark
          onClick={redirectTo}
          label={t('BANNER_FREE_CTA')}
        />
      </div>
      <div className="absolute inset-0 flex justify-end">
        <div className="w-full h-full">
          <picture>
            <source src={bgDesktopWebp} type="image/webp" />
            <img
              src={bgDesktopJpg}
              alt={t('BANNER_FREE_TITLE')}
              className="object-cover w-full h-full"
            />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default BannerPremiumTrialDesktop;
